import axios from "axios";
import { message } from "antd";
let key=process.env.REACT_APP_API_KEY;
let apiURL = process.env.REACT_APP_API_URL;
let axios_instance = axios.create({
  baseURL: apiURL,
  timeout: 65000,
});
class MiCompAPI {
  invoke = (path, method, callback, data, params) => {
    let config = {
      method: method,
      url: path + "?versionQuery=v1",
    };
    if (data !== undefined) {
      config["data"] = data;
    }
    if (params !== undefined) {
      config["params"] = params;
    }
    if (path !== "Login") {
      const token = sessionStorage.getItem("token");
      config["headers"] = {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": key,
        "Ocp-Apim-Trace": true,
        TimeZone: new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1],
        IpAddress: "",
        "Access-Control-Allow-Origin": "*",
      };
    } else {
      config["headers"] = {
        "Access-Control-Allow-Origin": "*",
        "Ocp-Apim-Subscription-Key": key,
        "Ocp-Apim-Trace": true,
      };
    }
    axios_instance
      .request(config)
      .then((res) => {
        if (res.data.statusCode === 401) {
          window.location.pathname = "";
          sessionStorage.clear();
          message
            .loading("Session expired. Redirecting you to login page.", 4)
            .then(() => window.location.reload());
        }
        callback(res.data, true);
      })
      .catch((err) => {
        if (err.response && err.response.status === 403 && path !== "login") {
          message.destroy();
          message
            .loading("Session expired. Redirecting you to login page.", 4)
            .then(() => window.location.reload());
        } else {
          callback(null, false);
        }
      });
  };
}
export default MiCompAPI;
